import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { LoaderComponent } from './components/loader/loader.component';
import { FilterPipe } from './pipes/filter.pipe';
import { ImagePreloadDirective } from './directives/image-preload.directive';
import { ReplacePipe } from './pipes/replace.pipe';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NoDataComponent } from './components/no-data/no-data.component';
import { CookieModalComponent } from './components/cookie-modal/cookie-modal.component';
import { CleanHtmlPipe } from './pipes/clean-html.pipe';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CardLoaderComponent } from './components/card-loader/card-loader.component';
import { LoginComponent } from './components/login/login.component';
import { SearchComponent } from './components/search-modal/search-modal.component';
import { CountryModalComponent } from './components/country-modal/country-modal.component';
import { CreditCardMaskPipe } from './pipes/credit-card-mask.pipe';
import { OffersCardComponent } from './components/offers-card/offers-card.component';
import { CouponModalComponent } from './components/coupon-modal/coupon-modal.component';
import { AddCardModalComponent } from './components/addCard-modal/addCard-modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { RouterModule } from '@angular/router';
import { LazyImgDirective } from './directives/lazyload.directive';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { LoggedInCardComponent } from './components/logged-in-card/logged-in-card.component';
import { TagBasedOffersComponent } from './components/tag-based-offers/tag-based-offers.component';
import { CarouselModule } from "primeng/carousel"
import { TabMenuModule } from "primeng/tabmenu";
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { SvgIconModule } from '@pv-frontend/pv-shared-components/svg-icon';
import { SkeletonModule } from 'primeng/skeleton';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';


@NgModule({
    declarations: [
        // Components
        LoaderComponent,
        NoDataComponent,
        HeaderComponent,
        FooterComponent,
        LoginComponent,
        OffersCardComponent,
        CountryModalComponent,
        CookieModalComponent,
        SearchComponent,
        CouponModalComponent,
        CardLoaderComponent,
        AddCardModalComponent,
        // Directives
        ImagePreloadDirective,
        LazyImgDirective,
        // Pipes
        FilterPipe,
        ReplacePipe,
        CleanHtmlPipe,
        CreditCardMaskPipe,
        SentenceCasePipe,
        LoggedInCardComponent,
        TagBasedOffersComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot({
            closeButton: true,
            preventDuplicates: true,
            // disableTimeOut: true
        }),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PopoverModule.forRoot(),
        CollapseModule.forRoot(),
        RouterModule,
        AccordionModule.forRoot(),
        CarouselModule,
        TabMenuModule,
        SidebarModule,
        ButtonModule,
        SvgIconModule,
        SkeletonModule,
    ],
    exports: [
        // Modules
        FormsModule,
        ReactiveFormsModule,
        BsDropdownModule,
        ModalModule,
        PopoverModule,
        CollapseModule,
        RouterModule,
        AccordionModule,
        // Components
        LoaderComponent,
        NoDataComponent,
        HeaderComponent,
        FooterComponent,
        LoginComponent,
        OffersCardComponent,
        CountryModalComponent,
        CookieModalComponent,
        SearchComponent,
        CouponModalComponent,
        CardLoaderComponent,
        AddCardModalComponent,
        // Directives
        ImagePreloadDirective,
        LazyImgDirective,
        // Pipes
        FilterPipe,
        ReplacePipe,
        CleanHtmlPipe,
        CreditCardMaskPipe,
        SentenceCasePipe,
        TagBasedOffersComponent
    ],
    providers: []
})
export class SharedModule { }
